import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,

  // admin
  adminLoading: false,
  adminRows: [],
};

const npsAdminReducer = createReducer(initialState, {
  // ---------------- USER NPS ----------------
  NPS_ANSWER_REQ: (state) => {
    state.loading = true;
  },
  NPS_ANSWER_SUC: (state, action) => {
    state.loading = false;
    state.status = action.payload?.status ?? true;
    state.message = action.payload?.message ?? null;
    state.data = action.payload;
  },
  NPS_ANSWER_ERR: (state, action) => {
    state.loading = false;
    state.message = action.payload?.message;
  },

  // ---------------- ADMIN NPS ----------------
  ADMIN_NPS_REQ: (state) => {
    state.adminLoading = true;
  },
  ADMIN_NPS_SUC: (state, action) => {
    state.adminLoading = false;
    state.status = action.payload?.status ?? true;
    state.message = action.payload?.message ?? null;

  
    state.adminRows = Array.isArray(action.payload?.data)
      ? action.payload.data
      : [];
  },
  ADMIN_NPS_ERR: (state) => {
    state.adminLoading = false;
    state.adminRows = [];
  },
});

export default npsAdminReducer;
